export default __webpack_public_path__ + "static/media/IceTrackr_Homepage_Video.62916257.mp4";